import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import {
    CadastrarObraController,
    ConsultarEmpresaController,
    ConsultarObraController,
    ListarObrasController,
} from "../../../../../Controllers/Cobranca/Obras/ObrasController";
import {
    IEmpresa,
    IObra,
    IObraEmpresa,
} from "../../../../../Interfaces/Cobranca/Obras/ObrasInterfaces";
import { DeletarObraService } from "../../../../../Services/Cobranca/Obras/ObrasServices";
import SpinnerComponent from "../../../../Loding/Spinner";
import Table from "../../../../Table";

interface IformData {
    ID_OBRA: string;
    ID_EMPRESA: number;
}

export function Obras() {
    const [LstObrasCob, setLstObrasCob] = useState<Array<IObra>>();
    const [LstEmpresasUAU, setLstEmpresasUAU] = useState<Array<IEmpresa>>();
    const [LstObraEmpresasUAU, setLstObraEmpresasUAU] =
        useState<Array<IObraEmpresa>>();
    const { register, handleSubmit, formState } = useForm();

    useEffect(() => {
        updateList();
    }, [setLstObrasCob]);

    useEffect(() => {
        ConsultarEmpresaController().then((res) => {
            setLstEmpresasUAU(res);
        });
    }, []);

    function updateList() {
        ListarObrasController().then((res) => {
            setLstObrasCob(res);
        });
    }

    function handleCadastrarObraFormSubmit(formData: IformData) {
        CadastrarObraController({
            ID_CASO_COBRANCA_OBRAS: 0,
            ID_OBRA: formData.ID_OBRA,
            ID_EMPRESA: formData.ID_EMPRESA,
        });
    }

    function RowTable(cell: any, row: IObra) {
        return (
            <div className="rowCapysRC d-flex justify-content-between align-itens-center flex-column">
                <p className="p-3 font-weight-bold">
                    {row.ID_ERP_EMPRESA_OBRA}
                </p>
            </div>
        );
    }

    function RowEmpresa(cell: any, row: IObra) {
        return (
            <div className="d-flex justify-content-between align-itens-center flex-column">
                <p className="p-3 font-weight-bold">{row.ID_EMPRESA}</p>
            </div>
        );
    }

    function RowUser(cell: any, row: IObra) {
        return (
            <div className="d-flex justify-content-between align-itens-center flex-column">
                <p className="p-3 font-weight-bold">{row.DS_USUARIO}</p>
            </div>
        );
    }

    function RowDate(cell: any, row: IObra) {
        return (
            <div className="d-flex justify-content-between align-itens-center flex-column">
                <p className="p-3 font-weight-bold">
                    {moment(row.DT_CADASTRO).format("lll")}
                </p>
            </div>
        );
    }
    function RowDelete(cell: any, row: IObra) {
        return (
            <div className="d-flex justify-content-center align-itens-center">
                <button
                    className="btn  btn-sm btn-outline-danger font-weight-bold"
                    onClick={() => {
                        Swal.fire({
                            title: "Deseja apagar esta obra?",
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText:
                                "<i class='la la-check'></i> Sim!",
                            showCancelButton: true,
                            cancelButtonText:
                                "<i class='la la-thumbs-down'></i> Não",
                            customClass: {
                                confirmButton: "btn btn-outline-success",
                                cancelButton: "btn btn-default",
                            },
                        }).then((result) => {
                            if (result.isConfirmed) {
                                DeletarObraService(
                                    row.ID_CASO_COBRANCA_OBRAS
                                ).then(() => {
                                    updateList();
                                });
                            }
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} size="lg" />
                </button>
            </div>
        );
    }

    const ColunsObras: Array<ColumnDescription> = [
        {
            dataField: "ID_ERP_EMPRESA_OBRA",
            text: "Obra",
            formatter: RowTable,
            sort: true,
            isDummyField: true,
        },
        {
            dataField: "ID_EMPRESA",
            text: "Empresa",
            formatter: RowEmpresa,
            sort: true,
            isDummyField: true,
        },
        {
            dataField: "DS_USUARIO",
            text: "Usuário",
            formatter: RowUser,
            sort: true,
            isDummyField: true,
        },
        {
            dataField: "DT_CADASTRO",
            text: "Data Cadastro",
            formatter: RowDate,
            sort: true,
            isDummyField: true,
        },
        {
            dataField: "ID_EMPRESA",
            text: "",
            formatter: RowDelete,
            sort: true,
            isDummyField: true,
        },
    ];

    return LstObrasCob !== undefined ? (
        <div className="">
            <div className="col-12 collapse mb-5" id="collapseForm">
                <h5 className="text-center">Cadastre Obra Cobrança</h5>
                <form
                    onSubmit={handleSubmit(handleCadastrarObraFormSubmit)}
                    className="w-100 align-itens-center"
                >
                    <div className="row mb-3">
                        <div className="col-12 col-lg-6">
                            <label htmlFor="classificacao">Empresas</label>
                            <select
                                name="ID_EMPRESA"
                                className={`form-control placeholder-dark-50 ${
                                    formState.errors.classificacao &&
                                    "is-invalid"
                                }`}
                                ref={register({
                                    required: "Insira a empresa",
                                })}
                                onChange={(event) => {
                                    if (
                                        Number.parseInt(event.target.value) !==
                                        0
                                    ) {
                                        ConsultarObraController(
                                            Number.parseInt(event.target.value)
                                        ).then((res) => {
                                            setLstObraEmpresasUAU(res);
                                        });
                                    }
                                    setLstObraEmpresasUAU([]);
                                }}
                            >
                                <option value={0}></option>
                                {LstEmpresasUAU ? (
                                    LstEmpresasUAU.map((empresa) => {
                                        return (
                                            <option
                                                key={empresa.ID_EMPRESA}
                                                value={empresa.ID_EMPRESA}
                                            >
                                                {empresa.DS_EMPRESA}
                                            </option>
                                        );
                                    })
                                ) : (
                                    <option value={0}>
                                        Não foi encontrado nenhuma empresa.
                                    </option>
                                )}
                            </select>
                        </div>

                        <div className="col-12 col-lg-6">
                            <label htmlFor="classificacao">Obras</label>
                            <select
                                name="ID_OBRA"
                                className={`form-control placeholder-dark-50 ${
                                    formState.errors.classificacao &&
                                    "is-invalid"
                                }`}
                                ref={register({
                                    required:
                                        "Insira a classificacao do contato",
                                })}
                                disabled={LstObraEmpresasUAU?.length === null}
                            >
                                <option></option>
                                {LstObraEmpresasUAU?.length ? (
                                    LstObraEmpresasUAU.map((Obra) => {
                                        return (
                                            <option
                                                key={Obra.ID_OBRA}
                                                value={Obra.ID_OBRA}
                                            >
                                                {Obra.DS_OBRA}
                                            </option>
                                        );
                                    })
                                ) : (
                                    <option>Selecione uma empresa.</option>
                                )}
                            </select>
                        </div>
                    </div>

                    <button className="btn btn-outline-success font-weight-bold d-flex col-12 justify-content-center">
                        <FontAwesomeIcon
                            icon={faPlus}
                            size="lg"
                            className="mr-1"
                        />{" "}
                        Cadastrar
                    </button>
                </form>
            </div>

            <div className="table-responsive-sm">
                <Table
                    keyField="ID_ERP_EMPRESA_OBRA"
                    data={LstObrasCob}
                    columns={ColunsObras}
                    noDataIndication={"Não existe obra"}
                />
            </div>
        </div>
    ) : (
        <SpinnerComponent />
    );
}
